import React, { Component } from "react";
import { Link } from "react-router-dom";
import { theme } from "../../assets/theme/theme";

class TrainingEvaluationList extends Component {
  renderStatus(status) {
    const map = {
      Pending: { bg: "#FFF7E6", color: "#B76E00" },
      Submitted: { bg: "#ECFDF3", color: "#027A48" },
      Overdue: { bg: "#FEECEC", color: "#B42318" },
      Draft: { bg: "#F1F5F9", color: "#475569" },
    };

    const s = map[status] || map.Draft;

    return (
      <span
        style={{
          background: s.bg,
          color: s.color,
          padding: "5px 10px",
          borderRadius: 8,
          fontSize: 12,
          fontWeight: 800,
        }}
      >
        {status}
      </span>
    );
  }

  renderCard(label, value, subText) {
    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          padding: 18,
          flex: 1,
        }}
      >
        <div style={{ fontSize: 12, fontWeight: 700, color: "#64748B" }}>{label}</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: "#0F172A", marginTop: 8 }}>
          {value}
        </div>
        <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 4 }}>{subText}</div>
      </div>
    );
  }

  render() {
    const rows = [
      {
        id: "EVA-2026-001",
        request_id: "TRN-2026-0012",
        course: "Digital Marketing Masterclass",
        provider: "AIM Academy",
        completed_date: "17 Jun 2026",
        due_date: "24 Jun 2026",
        score: "-",
        status: "Pending",
      },
      {
        id: "EVA-2026-002",
        request_id: "TRN-2026-0011",
        course: "Finance for Non-Finance",
        provider: "BEC Learning",
        completed_date: "10 May 2026",
        due_date: "17 May 2026",
        score: "4.5 / 5",
        status: "Submitted",
      },
      {
        id: "EVA-2026-003",
        request_id: "TRN-2026-0010",
        course: "Event Management 101",
        provider: "MyCEB",
        completed_date: "04 Apr 2026",
        due_date: "11 Apr 2026",
        score: "-",
        status: "Overdue",
      },
      {
        id: "EVA-2026-004",
        request_id: "TRN-2026-0009",
        course: "Leadership Development",
        provider: "IPMA",
        completed_date: "21 Mar 2026",
        due_date: "28 Mar 2026",
        score: "-",
        status: "Draft",
      },
    ];

    return (
      <div style={{ padding: 24 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 24,
          }}
        >
          <div>
            <h4 style={{ margin: 0, fontWeight: 800 }}>Training Evaluations</h4>
            <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
              Complete and track post-training evaluation forms.
            </p>
          </div>

          <Link
            to="/training/request"
            style={{
              background: theme.colors.brand.primary,
              color: "#fff",
              padding: "10px 16px",
              borderRadius: 8,
              textDecoration: "none",
              fontWeight: 800,
              fontSize: 13,
            }}
          >
            View Training Requests
          </Link>
        </div>

        <div style={{ display: "flex", gap: 14, marginBottom: 22 }}>
          {this.renderCard("Pending Evaluation", 5, "Awaiting submission")}
          {this.renderCard("Submitted", 18, "Completed evaluations")}
          {this.renderCard("Overdue", 2, "Require follow-up")}
          {this.renderCard("Average Score", "4.4", "Out of 5")}
        </div>

        <div
          style={{
            background: "#fff",
            border: "1px solid #E5E7EB",
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 1fr 1fr 1fr auto",
              gap: 12,
              padding: 16,
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            <input
              placeholder="Search by course, request ID or provider..."
              style={inputStyle}
            />

            <select style={inputStyle}>
              <option>Status</option>
              <option>Pending</option>
              <option>Submitted</option>
              <option>Overdue</option>
              <option>Draft</option>
            </select>

            <select style={inputStyle}>
              <option>Department</option>
              <option>Digitalisation</option>
              <option>Finance</option>
              <option>Marketing</option>
            </select>

            <input type="date" style={inputStyle} />

            <button style={secondaryButton}>Filter</button>
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#F8FAFC", color: "#475569", fontSize: 12 }}>
                {[
                  "Evaluation ID",
                  "Training Request",
                  "Course / Program",
                  "Provider",
                  "Completed Date",
                  "Due Date",
                  "Score",
                  "Status",
                  "Action",
                ].map((h) => (
                  <th key={h} style={thStyle}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows.map((row) => (
                <tr key={row.id} style={{ borderTop: "1px solid #E5E7EB" }}>
                  <td style={tdStyle}>
                    <Link
                      to={`/training/evaluations/${row.id}`}
                      style={{
                        color: theme.colors.brand.primary,
                        fontWeight: 800,
                        textDecoration: "none",
                      }}
                    >
                      {row.id}
                    </Link>
                  </td>
                  <td style={tdStyle}>{row.request_id}</td>
                  <td style={tdStyle}>{row.course}</td>
                  <td style={tdStyle}>{row.provider}</td>
                  <td style={tdStyle}>{row.completed_date}</td>
                  <td style={tdStyle}>{row.due_date}</td>
                  <td style={tdStyle}>{row.score}</td>
                  <td style={tdStyle}>{this.renderStatus(row.status)}</td>
                  <td style={tdStyle}>
                    {row.status === "Submitted" ? (
                      <Link to={`/training/evaluations/${row.id}`} style={smallButton}>
                        View
                      </Link>
                    ) : (
                      <Link to={`/training/evaluations/${row.id}`} style={primarySmallButton}>
                        Evaluate
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ padding: 16, color: "#64748B", fontSize: 12 }}>
            Showing 1 to 4 of 25 entries
          </div>
        </div>
      </div>
    );
  }
}

const inputStyle = {
  height: 38,
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
};

const thStyle = {
  padding: "12px 14px",
  textAlign: "left",
  fontWeight: 800,
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: "14px",
  fontSize: 13,
  color: "#334155",
  verticalAlign: "middle",
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "9px 14px",
  fontWeight: 800,
  cursor: "pointer",
};

const smallButton = {
  ...secondaryButton,
  display: "inline-block",
  padding: "6px 10px",
  fontSize: 12,
  textDecoration: "none",
};

const primarySmallButton = {
  background: theme.colors.brand.primary,
  color: "#fff",
  borderRadius: 8,
  padding: "7px 11px",
  fontWeight: 800,
  fontSize: 12,
  textDecoration: "none",
  display: "inline-block",
};

export default TrainingEvaluationList;